"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetDimensions = exports.divideBarIntoEqualParts = void 0;
var __1 = require("..");
var styled_1 = require("../styled");
var divideBarIntoEqualParts = function (num) {
    if (num <= 100)
        return num;
    if (num <= 200)
        return 200;
    if (num <= 500)
        return 500;
    if (num <= 1000)
        return 1000;
    var magnitude = Math.pow(10, Math.floor(Math.log10(num)));
    return Math.ceil(num / magnitude) * magnitude;
};
exports.divideBarIntoEqualParts = divideBarIntoEqualParts;
var useGetDimensions = function (data, maxHeight, containerWidth, totalDataCount, highestCount) {
    var singleBarWidth;
    var totalBars = data === null || data === void 0 ? void 0 : data.reduce(function (total, tagCategory) {
        var _a;
        return total += (_a = tagCategory.tagSpecificCount) === null || _a === void 0 ? void 0 : _a.length;
    }, 0);
    var totalGapSpace = (totalBars - 1) * Math.floor(__1.BAR_GAP * 10); // BAR GAP, example 0.3 converted 3Px
    var availableWidthForBars = (containerWidth - totalGapSpace) - (styled_1.CONTAINER_PADDING * 2); // CONTAINER_PADDING Left right 10 * 10  = 20
    // const defaultWidthForBars = (totalBars - 1) * DEFAULT_SINGLE_BAR_WIDTH - (CONTAINER_PADDING * 2);
    var dynamicBarWidth = availableWidthForBars / totalBars;
    singleBarWidth = Math.max(dynamicBarWidth, __1.DEFAULT_SINGLE_BAR_WIDTH);
    // Calculate the ceiling value for the highest count
    var barSections = (0, exports.divideBarIntoEqualParts)(highestCount);
    return data === null || data === void 0 ? void 0 : data.map(function (category) {
        // total count for this category
        var total = category.tagSpecificCount.reduce(function (sum, tag) { return sum + tag.count; }, 0);
        var barsInCategory = category.tagSpecificCount.length;
        var gapsInCategory = Math.max(0, barsInCategory - 1); // One less gap than bars
        var categoryTotalWidth = (barsInCategory * singleBarWidth) + (gapsInCategory * Math.floor(__1.BAR_GAP * 10));
        // percentage to each tag
        return __assign(__assign({}, category), { width: categoryTotalWidth, tagSpecificCount: category.tagSpecificCount.map(function (tag) {
                // Original percentage relative to total dataset
                var percentage = Number((tag.count / (totalDataCount || total) * 100).toFixed(1));
                // New height calculation relative to highest count and ceiling
                // This creates a "zoomed in" effect where bars are more visible
                var relativeHeight = Math.round((tag.count / barSections) * maxHeight);
                return __assign({ percentage: percentage, height: relativeHeight, width: singleBarWidth, barSections: barSections }, tag);
            }) });
    });
};
exports.useGetDimensions = useGetDimensions;
